import { Card, IconTile } from "@peer-start/ui";
import { Trophy } from "lucide-react";
import { useTranslation } from "react-i18next";
import feedback from "../../../assets/courses/feedback.jpg";
import grenzen from "../../../assets/courses/grenzen.jpg";
import lesstart from "../../../assets/courses/lesstart.jpg";
import onrust from "../../../assets/courses/onrust.jpg";
import oudergesprek from "../../../assets/courses/oudergesprek.jpg";
import { topCourseFollowThrough } from "../data/manager-dashboard.js";

const thumbnails: Record<string, string> = {
  lesstart,
  onrust,
  oudergesprek,
  grenzen,
  feedback,
};

export function ManagerCourseTop() {
  const { t } = useTranslation();
  const courses = topCourseFollowThrough();
  const percent = (value: number) => t("managerDashboard.usage.percent", { value });

  return (
    <Card
      aria-labelledby="manager-courses-title"
      className="h-full"
      data-control-id="manager.dashboard.courses"
      padding="compact"
    >
      <div className="flex items-center gap-4">
        <IconTile>
          <Trophy className="size-5" />
        </IconTile>
        <h2 className="text-base font-medium" id="manager-courses-title">
          {t("managerDashboard.courses.title")}
        </h2>
      </div>
      <table className="mt-5 w-full table-fixed">
        <thead>
          <tr className="text-left text-xs text-muted-foreground">
            <th className="pb-3 font-normal" scope="col">
              {t("managerDashboard.courses.course")}
            </th>
            <th className="w-24 pb-3 font-normal" scope="col">
              {t("managerDashboard.courses.recommended")}
            </th>
            <th className="w-24 pb-3 font-normal" scope="col">
              {t("managerDashboard.courses.clicked")}
            </th>
            <th className="w-16 pb-3 font-normal" scope="col">
              {t("managerDashboard.courses.started")}
            </th>
          </tr>
        </thead>
        <tbody className="text-sm">
          {courses.map((course) => (
            <tr className="border-t border-border/60" key={course.id}>
              <td className="py-3 pr-4">
                <div className="flex min-w-0 items-center gap-3">
                  <img
                    alt=""
                    className="size-10 shrink-0 rounded-lg object-cover"
                    src={thumbnails[course.id]}
                  />
                  <p className="truncate" title={course.title}>
                    {course.title}
                  </p>
                </div>
              </td>
              <td className="py-3 tabular-nums">{percent(course.recommendedShare)}</td>
              <td className="py-3 tabular-nums">{percent(course.clickedShare)}</td>
              <td className="py-3 tabular-nums">{percent(course.startedShare)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Card>
  );
}
